module.exports = __webpack_public_path__ + "ba41e6ef569f424cce5af110c722cfd4.pdf";